<template>
  <div class="flex items-center space-x-2">
    <div class="text-3xl font-bold text-[#aaaaaa]">askrabbit</div>
  </div>
</template>
